import { APP_API_KEY } from "@constant";

export const REVIEWER_LOCALSTORAGE_STRUCTURE = {
  isLoggedIn: false,
  apiKey: APP_API_KEY,
  sessionToken: "",
  sessionId: "",
  email: "",
  firstName: "",
  lastName: "",
  dfId: 0,
  userid: 0,
  eventid: 0,
};

export const REVIEWER_API_ERROR_CODES = {
  invalidCred: "kWrongCred",
  invalidUser: "kReviewerNotFound",
  noEventData: "kInvalidEventText",
};

export const REVIEWER_RESPONSE_TYPES = {
  reviewed: "reviewed",
  unReviewed: "unreviewed",
};

export const REVIEW_ALLOWANCES = {
  yet: "yet-to-start",
  allowed: "allowed",
  over: "time-over",
};

export const PROPOSAL_SUBMISSION_TYPES = {
  types: ["reject", "resubmit"],
  reject: {
    status: REVIEWER_RESPONSE_TYPES.reviewed,
    mark: "reject",
  },
  resubmit: {
    status: REVIEWER_RESPONSE_TYPES.unReviewed,
    mark: "resubmit",
  },
};

export const REVIEWER_API_PAYLOAD_STRUCTURES = {
  login: {
    email: "",
    password: "",
    duration: 0,
  },
  fetchReviewer: {
    dfid: 0,
    eventid: 0,
    type: "fetchreviewer",
  },
  reviewerResponses: {
    reviewerid: 0,
    eventid: 0,
    type: "fetchresponsesforreviewer",
  },
  reviewerAllCriteria: {
    eventid: 0,
    type: "fetchallreviewercriteria",
  },
  reviewerAllReviews: {
    eventid: 0,
    type: "fetchallproposalreview",
  },
  proposalResubmission: {
    eventid: 0,
    id: 0, // proposal_response table primary key
    comment: null,
  },
};

export const REVIEWER_REDUCER_STRUCTURES = {
  reviewResponses: {
    unreviewed: [],
    reviewed: [],
  },
};
